import * as Sentry from '@sentry/react';

import { KEYS_TO_REMOVE_FROM_BODY } from '@src/constants';
import { SENTRY_BLOCKED_BREADCRUMB_DOMAINS } from '@src/constants/sentry.constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sanitizeSensitiveData = (value: any): any => {
  if (typeof value === 'string') {
    try {
      const parsedValue = JSON.parse(value);

      if (
        parsedValue !== null &&
        (typeof parsedValue === 'object' || Array.isArray(parsedValue))
      ) {
        return JSON.stringify(sanitizeSensitiveData(parsedValue));
      }
    } catch {
      // It's just a regular string, return it as is
    }

    return value;
  }

  if (Array.isArray(value)) {
    return value.map(sanitizeSensitiveData);
  }

  if (value !== null && typeof value === 'object') {
    const newObj = { ...value };

    for (const key of Object.keys(newObj)) {
      const normalizedKey = key.toLowerCase();

      const shouldRemove = KEYS_TO_REMOVE_FROM_BODY.some((keyPart) =>
        normalizedKey.includes(keyPart),
      );

      if (shouldRemove) {
        delete newObj[key];
      } else {
        newObj[key] = sanitizeSensitiveData(newObj[key]);
      }
    }

    return newObj;
  }

  return value;
};

interface IBreadcrumbHint {
  xhr?: XMLHttpRequest;
}

export const isUrlFromBlockedDomain = (
  breadcrumb: Sentry.Breadcrumb,
  hint?: IBreadcrumbHint,
): boolean => {
  const isHttpBreadcrumb =
    breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch';

  if (!isHttpBreadcrumb) return false;

  const url =
    hint?.xhr?.responseURL ||
    breadcrumb.data?.url ||
    breadcrumb.data?.responseUrl;

  if (typeof url !== 'string') return false;

  try {
    const { hostname } = new URL(url, window.location.origin);

    return SENTRY_BLOCKED_BREADCRUMB_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
};
